import GameComponent from "game/app/components/game/game-component";
import BonusTaskForm from "../../common/bonus-task-form";
import React from "react";

class BCComponent extends GameComponent {

    componentWillMount() {
        this.props.getBonusTasks(this.getInstanceId());
    }

    submitBonusTask(task) {
        return (values, form) => {
            this.props.submitBonusTask(this.getInstanceId(), task.id, values).then(() => {
                form.resetForm();
                form.setSubmitting(false);
            });
        }
    }

    showTask(identifier) {
        return this.props.bonusTasks.list
            .filter((task) => task.properties && task.properties.identifier === identifier )
            .map((task) => <BonusTaskForm key={task.id} resource={task} handleSubmit={this.submitBonusTask(task)}/>)
    }

}

export default BCComponent;
